import Button from "devextreme-react/button";
import dxDataGrid from "devextreme/ui/data_grid";
import jsPDF from "jspdf";
import { exportDataGrid as exportDataGridToPdf } from 'devextreme/pdf_exporter';
import { useTitle } from "../../contexts/title";

export default function ExportToPdfButton(props: { dataGrid: dxDataGrid }) {
	const { title } = useTitle();
	const fileName = title.replace(/[^a-z0-9_-]/gi, '_') + '.pdf';

	function getColumnWidths(pageWidth: number) {
		const columnWidths: number[] = [];
		const columns = props.dataGrid.getVisibleColumns();
		let columnSize = (pageWidth-30) / columns.length;
		columns.forEach(f => columnWidths.push(columnSize));
		console.log(columnWidths);
		return columnWidths;
	}

	return (
		<Button
			text="Print"
			icon="Inscyth-Print"
			onClick={() => {
				const doc = new jsPDF("landscape");
				exportDataGridToPdf({
					jsPDFDocument: doc,
					component: props.dataGrid,
					columnWidths: getColumnWidths(doc.internal.pageSize.getWidth()),
					customizeCell: function (options) {
					 	const { gridCell, pdfCell } = options;
					 	if (pdfCell) {
					 		pdfCell.font = { size: 6, style: gridCell?.rowType === 'data' ? 'normal' : 'bold', name: 'Helvetica' };
							pdfCell.wordWrapEnabled = true;
					 	}
					}
				}).then(() => {
					doc.save(fileName);
				});
			}} >
		</Button>
	)
}
